/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/FirstRunExperience/Steps/FirstRunExperienceStepStatus" />
import * as React from "react";
import { IStatusProps, StatusSize } from "VSSUI/Status";
import { getSafeId } from "VSSUI/Util";

let statusId = 1;

function _numberOne(props: { ariaLabel?: string; className: string; size: StatusSize }): JSX.Element {
    const role = props.ariaLabel ? "img" : "presentation";
    const descId = props.ariaLabel ? getSafeId(`status-${statusId++}-desc`) : undefined;

    return (
        <svg
            aria-labelledby={descId}
            className={props.className}
            role={role}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="16" cy="16" r="16" />
            <path
                d="M17.7798 10.5127V21.25H15.4727V13.1201C15.3457 13.2324 15.1943 13.3398 15.0186 13.4424C14.8477 13.54 14.6646 13.6304 14.4692 13.7134C14.2739 13.7915 14.0713 13.8599 13.8613 13.9185C13.6514 13.9722 13.4438 14.0112 13.2388 14.0356V12.0874C13.8394 11.9116 14.4058 11.687 14.938 11.4136C15.4702 11.1401 15.9512 10.8398 16.3809 10.5127H17.7798Z"
                fill="white"
            />
        </svg>
    );
}

function _numberTwo(props: { ariaLabel?: string; className: string; size: StatusSize }): JSX.Element {
    const role = props.ariaLabel ? "img" : "presentation";
    const descId = props.ariaLabel ? getSafeId(`status-${statusId++}-desc`) : undefined;

    return (
        <svg
            aria-labelledby={descId}
            className={props.className}
            role={role}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="16" cy="16" r="16" />
            <path
                d="M14.8281 19.3311H19.2812V21.25H12.2939V20.459C12.2939 19.9219 12.3843 19.4409 12.5649 19.0161C12.7456 18.5864 12.9727 18.2031 13.2461 17.8662C13.5195 17.5244 13.8174 17.2241 14.1396 16.9653C14.4668 16.7017 14.7769 16.4648 15.0698 16.2549C15.3774 16.0352 15.646 15.8252 15.8755 15.625C16.1099 15.4248 16.3052 15.2271 16.4614 15.0317C16.6226 14.8315 16.7422 14.6313 16.8203 14.4312C16.8984 14.2261 16.9375 14.0088 16.9375 13.7793C16.9375 13.3301 16.8105 12.9907 16.5566 12.7612C16.3027 12.5317 15.9146 12.417 15.3921 12.417C14.4888 12.417 13.6245 12.7759 12.7993 13.4937V11.4575C13.7124 10.8667 14.7427 10.5713 15.8901 10.5713C16.4224 10.5713 16.8984 10.6421 17.3184 10.7837C17.7432 10.9204 18.1021 11.1182 18.395 11.377C18.688 11.6357 18.9102 11.9507 19.0615 12.3218C19.2178 12.688 19.2959 13.0981 19.2959 13.5522C19.2959 14.0356 19.2202 14.4653 19.0688 14.8413C18.9224 15.2173 18.7246 15.5591 18.4756 15.8667C18.2314 16.1743 17.9482 16.4575 17.626 16.7163C17.3037 16.9702 16.9692 17.2168 16.6226 17.4561C16.3882 17.6221 16.1611 17.7881 15.9414 17.9541C15.7266 18.1152 15.5361 18.2764 15.3701 18.4375C15.2041 18.5938 15.0723 18.7476 14.9746 18.8989C14.877 19.0503 14.8281 19.1943 14.8281 19.3311Z"
                fill="white"
            />
        </svg>
    );
}

export const NumberOne: IStatusProps = {
    color: "neutral",
    onRenderIcon: (className: string, size: StatusSize, animated?: boolean, ariaLabel?: string) => _numberOne({ ariaLabel, className, size })
};

export const NumberTwo: IStatusProps = {
    color: "neutral",
    onRenderIcon: (className: string, size: StatusSize, animated?: boolean, ariaLabel?: string) => _numberTwo({ ariaLabel, className, size })
};
